import React, { ReactElement } from 'react';

import Chip from '@mui/material/Chip';

import { getProductionKeyLabel, ProductionKey } from 'src/constants/ProductionKey';

import { ChipProps } from '@mui/material';
import OilIcon from 'src/icons/OilIcon';
import FryingIcon from 'src/icons/FyingIcon';
import SeedsSackIcon from 'src/icons/SeedsSackIcon';

export default function ProductionChip({
  type,
  label,
  color = 'secondary',
  ...otherProps
}: ChipProps & {
  type: ProductionKey;
}) {
  const finalLabel = label || getProductionKeyLabel({ key: type });

  let Icon: ReactElement | undefined;
  switch (type) {
    case ProductionKey.AZEITE:
      Icon = <OilIcon color="drawer" />;
      break;
    case ProductionKey.OLEO:
      Icon = <FryingIcon color="drawer" />;
      break;
    case ProductionKey.FLOCOS:
      Icon = <SeedsSackIcon color="drawer" />;
      break;
  }

  return <Chip color={color} label={finalLabel} icon={Icon} {...otherProps} />;
}
